import React from 'react';
import { formatDate } from '../utils';
import { Badge } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';

const Tags = ({ open, patientProfile, themeStyle }) => {
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  const displayExpiration = !selectedTenancy?.features?.tags?.hideExpiration;
  const getExpiration = (exp) => {
    if (displayExpiration) {
      return ` (${formatDate(exp)})`;
    }
    return '';
  };
  const uniqueTagNameWithExpiration = [
    ...new Set(
      patientProfile.tags?.map(
        (tag) => tag.tag_name + getExpiration(tag.expiration_time),
      ) ?? [],
    ),
  ];

  return open ? (
    <div className="tag-container">
      {uniqueTagNameWithExpiration.map((tag, i) => (
        <Badge
          className={
            themeStyle === 'AUTOMEDIC'
              ? 'tag-automedic-fullname'
              : 'tagFullName'
          }
          key={i + '' + tag}
          style={{ cursor: 'default' }}
          data-tip={tag}
        >
          {tag.replace(getExpiration(tag.expiration_time), '')}
        </Badge>
      ))}
      <ReactTooltip place="bottom" effect="solid" className="w-25" />
    </div>
  ) : (
    <div className="short-name-container">
      {uniqueTagNameWithExpiration.map((tag, i) => (
        <Badge
          className={
            themeStyle === 'AUTOMEDIC' ? 'tag-automedic-name' : 'tagShortName'
          }
          key={i + '' + tag}
          style={{ cursor: 'default' }}
          data-tip={tag}
        >
          {tag.replace(getExpiration(tag.expiration_time), '')}
        </Badge>
      ))}
      {uniqueTagNameWithExpiration.length > 2 && (
        <Badge
          className={
            themeStyle === 'AUTOMEDIC' ? 'tag-automedic-number' : 'tagNumber'
          }
          data-tip={uniqueTagNameWithExpiration.slice(2).map((tag) => tag)}
          style={{ cursor: 'default' }}
        >
          +{uniqueTagNameWithExpiration.length - 2}
        </Badge>
      )}
      <ReactTooltip place="bottom" effect="solid" className="w-25" />
    </div>
  );
};

export default Tags;
